export const validateSlot = (items: Array<HTMLElement>, className: string, shadowRoot: ShadowRoot | null): void => {
    const slotted = !!items.length;
    if (!slotted) {
      const element = shadowRoot?.querySelector(className);
      element?.remove();
    }
}
